import { getServerUrl } from "config/backend";

import { FetchLeaderboardParams, LeaderboardApiResponse } from "./types";

export async function fetchLeaderboard(
  chainId: number,
  params: FetchLeaderboardParams
): Promise<LeaderboardApiResponse> {
  const baseUrl = getServerUrl(chainId, "/leaderboard");
  const url = new URL(baseUrl);

  if (params.metric) url.searchParams.append("metric", params.metric);
  if (params.period) url.searchParams.append("period", params.period);
  if (params.from !== undefined) url.searchParams.append("from", params.from.toString());
  if (params.to !== undefined) url.searchParams.append("to", params.to.toString());
  if (params.limit) url.searchParams.append("limit", params.limit.toString());
  if (params.offset) url.searchParams.append("offset", params.offset.toString());
  if (params.competitionId) url.searchParams.append("competitionId", params.competitionId);

  const res = await fetch(url.toString());
  if (!res.ok) {
    throw new Error(`Failed to fetch leaderboard: ${res.statusText}`);
  }
  return res.json();
}
